// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.fermentation_alert_kind_enum */
var FermentationAlertKindEnum;
(function (FermentationAlertKindEnum) {
    FermentationAlertKindEnum["NODE_OFFLINE"] = "NODE_OFFLINE";
    FermentationAlertKindEnum["INPUT_MISSING"] = "INPUT_MISSING";
    FermentationAlertKindEnum["DEVICE_FAULT"] = "DEVICE_FAULT";
    FermentationAlertKindEnum["PROCESS_LIMIT"] = "PROCESS_LIMIT";
})(FermentationAlertKindEnum || (FermentationAlertKindEnum = {}));
;
export default FermentationAlertKindEnum;
/** Zod schema for fermentation_alert_kind_enum */
export const fermentationAlertKindEnum = z.nativeEnum(FermentationAlertKindEnum);
//# sourceMappingURL=FermentationAlertKindEnum.js.map